// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"349e7be6","208":"55e1fd88","236":"80477222","353":"246e0595","512":"e3ebd16f","549":"e99895c8","813":"4215c8ee"}[chunkId] + ".chunk.js";
};